export default __webpack_public_path__ + "static/media/cover1.e490a46d.jpg";